export const THEORETICAL_PARTS = {
  LECTURE: 'Lecture',
  SEMINAR: 'Seminar'
};
